import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, mergeProps as _mergeProps, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6d415a81"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex items-center justify-between mb-2" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", { class: "text-sm font-bold text-gray-700" }, "Participantes do Grupo", -1))
const _hoisted_3 = { class: "text-xs text-gray-500" }
const _hoisted_4 = { class: "bg-gray-50 rounded-lg border border-gray-200 overflow-hidden" }
const _hoisted_5 = {
  key: 0,
  class: "py-8 text-center text-gray-400 text-sm flex flex-col items-center"
}
const _hoisted_6 = {
  key: 1,
  class: "max-h-[300px] overflow-y-auto"
}
const _hoisted_7 = { class: "flex items-center gap-3 overflow-hidden" }
const _hoisted_8 = { class: "text-xs font-bold text-white" }
const _hoisted_9 = { class: "flex flex-col text-left truncate" }
const _hoisted_10 = ["title"]
const _hoisted_11 = ["title"]

import { useCompanyStore } from '@/pinia-store/useCompanyStore'
import { useUserStore } from '@/pinia-store/useUsersStore'
import { storeToRefs } from 'pinia'
import { onMounted, ref, computed } from 'vue'
import { mdiMagnify, mdiAccount, mdiTrashCanOutline, mdiAccountMultiple } from '@mdi/js'


export default /*#__PURE__*/_defineComponent({
  __name: 'base.form',
  props: ['name', 'email', 'company', 'users', 'isUpdateGroup'],
  emits: ['update:name', 'update:email', 'update:company', 'update:users'],
  setup(__props, { emit }) {

const props = __props;




const setName = (v: string) => emit('update:name', v)
const setEmail = (v: string) => emit('update:email', v)
const setCompany = (v: string) => emit('update:company', v)

const userStore = useUserStore()
const companyStore = useCompanyStore()
const { listUsers } = storeToRefs(userStore)
const { listCompanies } = storeToRefs(companyStore)

const userToAdd = ref(null)

const availableUsers = computed(() => {
  const currentIds = props.users || []
  return listUsers.value.filter((u) => !currentIds.includes(u.value))
})

const selectedUsersDetails = computed(() => {
  const currentIds = props.users || []
  return currentIds
    .map((id: string) => listUsers.value.find((u) => u.value === id))
    .filter((u: any) => !!u)
})

const handleAddUser = (item: any) => {
  if (!item) return
  const currentUsers = props.users ? [...props.users] : []
  if (!currentUsers.includes(item.value)) {
    currentUsers.push(item.value)
    emit('update:users', currentUsers)
  }
  userToAdd.value = null
}

const handleRemoveUser = (userId: string) => {
  const currentUsers = props.users ? [...props.users] : []
  const newUsers = currentUsers.filter((id: string) => id !== userId)
  emit('update:users', newUsers)
}

const getInitials = (name: string) => {
  if (!name) return 'U'
  return name.substring(0, 2).toUpperCase()
}

onMounted(async () => {
  if (userStore.fetchUsers) {
    await userStore.fetchUsers()
  } else {
    await (userStore as any).getAllUsers()
  }

  await companyStore.getMyCompanies()
})

return (_ctx: any,_cache: any) => {
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_autocomplete = _resolveComponent("v-autocomplete")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_avatar = _resolveComponent("v-avatar")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_row = _resolveComponent("v-row")!

  return (_openBlock(), _createBlock(_component_v_row, { dense: "" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_col, {
        cols: "12",
        md: "6"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_text_field, {
            "onUpdate:modelValue": setName,
            "model-value": __props.name ? String(__props.name) : undefined,
            class: "w-full",
            label: "Nome do Grupo",
            color: "primary20",
            variant: "outlined",
            density: "comfortable",
            "hide-details": "auto"
          }, null, 8, ["model-value"])
        ]),
        _: 1
      }),
      _createVNode(_component_v_col, {
        cols: "12",
        md: "6"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_text_field, {
            "onUpdate:modelValue": setEmail,
            "model-value": __props.email ? String(__props.email) : undefined,
            class: "w-full",
            label: "Email",
            color: "primary20",
            variant: "outlined",
            density: "comfortable",
            "hide-details": "auto"
          }, null, 8, ["model-value"])
        ]),
        _: 1
      }),
      _createVNode(_component_v_col, {
        cols: "12",
        class: "mt-4"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_autocomplete, {
            disabled: __props.isUpdateGroup,
            "onUpdate:modelValue": setCompany,
            "model-value": __props.company ? String(__props.company) : undefined,
            items: _unref(listCompanies),
            class: "w-full",
            color: "primary20",
            label: "* Empresa",
            variant: "outlined",
            density: "comfortable",
            "hide-details": "auto"
          }, null, 8, ["disabled", "model-value", "items"])
        ]),
        _: 1
      }),
      _createVNode(_component_v_col, { cols: "12" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_divider, { class: "my-2" }),
          _createElementVNode("div", _hoisted_1, [
            _hoisted_2,
            _createElementVNode("span", _hoisted_3, _toDisplayString(__props.users?.length || 0) + " selecionado(s)", 1)
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_v_col, { cols: "12" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_autocomplete, {
            modelValue: userToAdd.value,
            "onUpdate:modelValue": [
              _cache[0] || (_cache[0] = ($event: any) => ((userToAdd).value = $event)),
              handleAddUser
            ],
            items: availableUsers.value,
            label: "Adicionar pessoas ao grupo",
            color: "primary20",
            variant: "outlined",
            density: "compact",
            "hide-details": "",
            "clear-on-select": "",
            placeholder: "Pesquise por nome ou email",
            "no-data-text": "Nenhum usuário encontrado ou todos já selecionados",
            "return-object": ""
          }, {
            "prepend-inner": _withCtx(() => [
              _createVNode(_component_v_icon, {
                icon: _unref(mdiMagnify),
                color: "gray"
              }, null, 8, ["icon"])
            ]),
            item: _withCtx(({ props, item }) => [
              _createVNode(_component_v_list_item, _mergeProps(props, {
                "prepend-icon": _unref(mdiAccount),
                title: item.raw.title,
                subtitle: item.raw.subtitle
              }), null, 16, ["prepend-icon", "title", "subtitle"])
            ]),
            _: 1
          }, 8, ["modelValue", "items"])
        ]),
        _: 1
      }),
      _createVNode(_component_v_col, {
        cols: "12",
        class: "mt-2"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_4, [
            (!__props.users || __props.users.length === 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _createVNode(_component_v_icon, {
                    icon: _unref(mdiAccountMultiple),
                    size: "large",
                    class: "mb-2 opacity-50"
                  }, null, 8, ["icon"]),
                  _createTextVNode(" Nenhum participante adicionado ainda. ")
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectedUsersDetails.value, (user) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: user.value,
                      class: "flex items-center justify-between p-3 border-b border-gray-100 last:border-0 bg-white hover:bg-gray-50 transition-colors"
                    }, [
                      _createElementVNode("div", _hoisted_7, [
                        _createVNode(_component_v_avatar, {
                          color: "primary30",
                          size: "36"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("span", _hoisted_8, _toDisplayString(getInitials(user.title)), 1)
                          ]),
                          _: 2
                        }, 1024),
                        _createElementVNode("div", _hoisted_9, [
                          _createElementVNode("span", {
                            class: "text-sm font-medium text-gray-800 truncate",
                            title: user.title
                          }, _toDisplayString(user.title), 9, _hoisted_10),
                          _createElementVNode("span", {
                            class: "text-xs text-gray-500 truncate",
                            title: user.subtitle
                          }, _toDisplayString(user.subtitle), 9, _hoisted_11)
                        ])
                      ]),
                      _createVNode(_component_v_btn, {
                        icon: "",
                        variant: "text",
                        density: "comfortable",
                        color: "red-lighten-1",
                        onClick: ($event: any) => (handleRemoveUser(user.value)),
                        title: "Remover usuário"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_icon, {
                            icon: _unref(mdiTrashCanOutline),
                            size: "small"
                          }, null, 8, ["icon"])
                        ]),
                        _: 2
                      }, 1032, ["onClick"])
                    ]))
                  }), 128))
                ]))
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})